// Variables de ambiente. 
// Este archivo debe estar IGNORADO en el repositorio.
// NO USAR LAS VARIABLES DECLARADAS AQUÍ DIRECTAMENTE. Se deben declarar formalmente en config.js
// y luego usarlas desde allí. Véase config.js para saber como recuperar los valores declarados aquí.

export const URL_API_BOLETAS = 'https://cn68i6qm0g.execute-api.us-east-1.amazonaws.com/prod';
export const URL_API_HORA = 'https://p2r2e1a7yh.execute-api.us-east-1.amazonaws.com/dev/hora';

// a peticion de sii se saca la url de login de env vars

export const _PROVIDER = 'sii.login';

export const IdentityPoolId = 'us-east-1:e154b392-0e4e-47ad-a68f-5c814f8e3eb5';
export const awsRegion = 'us-east-1';

// export const IdentityPoolId = 'us-west-2:739c1895-29b8-4d30-a339-2f614ce7e083';
// export const awsRegion = 'us-west-2';

////////////////////////////
//// TODO por remover
export const USUARIOS_NOTIFICADORES = ['45000052-3'];
//////////////////////////////
//

export const DESCARGAR_CAF_URL = '/descargar-caf-prod';
// export const DESCARGAR_CAF_LAMBDA = 'cafAutomatico-prod';


export const API_CHECK_VERSION = 'https://370lj6fntj.execute-api.us-east-1.amazonaws.com/prod/version/:PLAT/verificar';

export const CLAVE_TRIBUTARIA_AMBIENTE = 'clave.w.sii.cl'
export const CLAVE_TRIBUTARIA_CALLBACK_URL = 'https://eboleta.sii.cl/emitir/'

export const CLAVE_TRIBUTARIA_CLIENT_ID = 'e0378e96-4014-4a47-b852-9d9246797f5c'
export const CLAVE_TRIBUTARIA_SCOPE = 'user_info'
export const CLAVE_TRIBUTARIA_STATE = '730b12d3-0586-42cb-8d8e-57c15125a8a9'

export const CLAVE_UNICA_AMBIENTE = ''
export const CLAVE_UNICA_CLIENT_ID = ''
export const CLAVE_UNICA_SCOPE = ''
export const CLAVE_UNICA_CALLBACK_URL = ''

export const PLATAFORMA = 'eboleta_web'

export const API_ENVIAR_EMAIL = 'https://sg7xg7pc48.execute-api.us-east-1.amazonaws.com/prod/enviar-email'
